module.exports = __webpack_public_path__ + "2d519184b08962d8e52cbac23b64e27f.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-320.webp
// module id = 212
// module chunks = 0